import { withScopedBaseStyles } from '@noths/polaris-client-ribbons-base';
import { SkipLinks as Component } from '@noths/polaris-client-ribbons-design-system';
export var SkipLinks = withScopedBaseStyles(Component);